export const BOTTOM = 'bottom'
export const CENTER = 'center'

export const SNACKBAR_CLOSE_REASON = 'clickaway'

export const AUTO_HIDE_DURATION = 3000